import { Spacer, Typography, useLayout } from '@capitalise/ui-design-system';
import useToggle from 'hooks/useToggle';

export const useDownload = () => {
  const [loadingDownload, toggleLoadingDownload] = useToggle(false);
  const { renderToaster } = useLayout();

  const handleDownload = async (fileName: string, errorMessage: string, getData: Function) => {
    toggleLoadingDownload();

    try {
      const { data } = await getData();

      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;

      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    } catch (e) {
      renderToaster(
        <Spacer gap="tiny" alignItems="center">
          <Typography size="body-14" color="white">
            {errorMessage}
          </Typography>
        </Spacer>,
      );
      throw e;
    } finally {
      toggleLoadingDownload();
    }
  };

  return { loadingDownload, handleDownload };
};
